import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function CirugiaOncologicaVeterinariaAlmeria() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Cirugía Oncológica Veterinaria Almería</strong>
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl leading-relaxed mb-8">
            <strong>Especialista en cirugía oncológica veterinaria en Almería</strong>. Resección de tumores con márgenes oncológicos, mastectomías y cirugía reconstructiva en tu clínica.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="https://wa.me/34600581975"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-2 bg-green-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp 24h</span>
            </a>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Oncología Quirúrgica Veterinaria</strong> Especializada
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Como <strong>especialista en cirugía oncológica veterinaria en Almería</strong>, me dedico al tratamiento quirúrgico de tumores en perros y gatos, realizando resecciones con márgenes oncológicos adecuados y cirugía reconstructiva cuando es necesario.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                La <strong>cirugía oncológica veterinaria</strong> requiere precisión, conocimiento anatómico profundo y experiencia en técnicas reconstructivas. Mi servicio móvil lleva esta especialización a tu clínica en <strong>Almería, Roquetas de Mar, El Ejido</strong> y toda la provincia.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Trabajo en coordinación con oncólogos veterinarios para ofrecer el mejor tratamiento integral, combinando cirugía con quimioterapia o radioterapia cuando está indicado.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/c0986d8e336e5d34fb1c380c12ef6842.jpg"
                alt="Cirugía oncológica veterinaria Almería - Resección de tumores especializada en perros y gatos"
                title="Oncología veterinaria Almería - Cirugía de tumores especializada"
                className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Cirugía Oncológica</strong> en Almería
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-microscope-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Resección de Tumores</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Extirpación de tumores cutáneos, subcutáneos y de tejidos blandos con márgenes oncológicos
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Mastectomías</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Mastectomía regional, unilateral o bilateral para tumores mamarios
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-scissors-cut-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía Reconstructiva</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Colgajos cutáneos y técnicas reconstructivas post-resección tumoral
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-surgical-mask-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Amputaciones</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Amputación de extremidades por osteosarcoma u otros tumores óseos
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-test-tube-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Biopsias Especializadas</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Biopsias incisionales y excisionales para diagnóstico histopatológico
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-stethoscope-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Tumores Abdominales</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Esplenectomías, nefrectomías y resecciones de tumores intraabdominales
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Approach Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Enfoque en Cirugía Oncológica</strong> Veterinaria
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Veterinary%20oncology%20surgical%20planning%20with%20tumor%20imaging%20and%20surgical%20instruments%2C%20detailed%20preparation%20for%20cancer%20surgery%20in%20pets%20showing%20professional%20medical%20planning%2C%20veterinary%20oncologist%20reviewing%20surgical%20approach%20with%20diagnostic%20images%20and%20specialized%20tools&width=600&height=500&seq=oncologia-planning-almeria-02&orientation=landscape"
                alt="Planificación cirugía oncológica veterinaria Almería - Márgenes oncológicos y técnica especializada"
                title="Planificación oncológica veterinaria Almería - Resección de tumores"
                className="w-full h-[400px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <strong>Márgenes Oncológicos</strong> Adecuados
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                En <strong>cirugía oncológica veterinaria</strong>, la clave del éxito es obtener márgenes quirúrgicos limpios. Planifico cada cirugía basándome en el tipo de tumor, su localización y comportamiento biológico.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Utilizo técnicas de marcaje tumoral y evaluación intraoperatoria para asegurar la resección completa con márgenes de seguridad apropiados según las guías oncológicas veterinarias.
              </p>
              <div className="bg-teal-50 rounded-lg p-6 border-l-4 border-teal-500">
                <h4 className="font-bold text-gray-900 mb-2">Protocolo Oncológico:</h4>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Evaluación preoperatoria completa</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Planificación de márgenes según tipo tumoral</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Técnicas reconstructivas cuando necesario</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-teal-600 mr-2 mt-1"></i>
                    <span>Coordinación con oncólogo para tratamiento integral</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Por Qué Elegir un <strong>Especialista en Oncología Quirúrgica</strong>?
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-focus-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Precisión Oncológica</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Conocimiento profundo de márgenes quirúrgicos y comportamiento tumoral para mejores resultados
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Enfoque Multidisciplinar</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Trabajo coordinado con oncólogos para tratamiento integral del paciente oncológico
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-add-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Cirugía Reconstructiva</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Técnicas avanzadas de reconstrucción para mantener calidad de vida post-cirugía
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Necesitas <strong>Cirugía Oncológica Veterinaria</strong> en Almería?
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            Contacta conmigo para valoración de casos oncológicos. Servicio de <strong>cirugía oncológica especializada</strong> en tu clínica de <strong>Almería</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="tel:+34600581975"
              className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}